import type { ComponentType } from "react";
import type { AssistantContentRef, AssistantContentType } from "../../../../api/types/assistantTypes";
import DataImportCard from "./data-import/DataImportCard";

interface CardProps {
  contentId: string;
  isOpen: boolean;
  onToggleOpen: () => void;
}

const cardComponents: Record<AssistantContentType, ComponentType<CardProps>> = {
  DataImport: DataImportCard,
};

interface Props {
  content: AssistantContentRef;
  isOpen: boolean;
  onToggleOpen: (content: AssistantContentRef) => void;
}

const ContentCard = ({ content, isOpen, onToggleOpen }: Props) => {
  const Card: ComponentType<CardProps> | undefined = cardComponents[content.type];
  if (!Card) {
    return null;
  }

  return <Card contentId={content.id} isOpen={isOpen} onToggleOpen={() => onToggleOpen(content)} />;
};

export default ContentCard;
